import { Check, ChevronsUpDown, Globe } from "lucide-react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/DropdownMenu"
import { flagForCurrency } from "@/components/ui/Flag"
import type { Market } from "@/lib/useMarket"

export function MarketFlag({ market }: { market: Market }) {
  const Flag = flagForCurrency(market.currency)
  return Flag ? <Flag size={16} className="flex-shrink-0" /> : null
}

type Props = {
  markets: Market[]
  value: Market | null
  onChange: (market: Market | null) => void
  // Home and Revenue offer "All markets" as well as each market.
  allowAll?: boolean
}

// The top bar's market filter: a full-height block at its left edge.
export default function MarketSelect({ markets, value, onChange, allowAll }: Props) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="flex h-full min-w-[180px] items-center gap-2 border-r border-border bg-muted/60 px-4 text-[13px] font-medium text-foreground transition-colors hover:bg-muted data-[state=open]:bg-muted"
        >
          {value ? <MarketFlag market={value} /> : <Globe size={15} />}
          {value ? value.name : allowAll ? "All markets" : "Pick a market"}
          <ChevronsUpDown size={14} className="ml-auto text-muted-foreground" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="min-w-[200px]">
        {allowAll && (
          <>
            <DropdownMenuItem onSelect={() => onChange(null)} className="justify-between gap-2">
              <span className="flex items-center gap-2"><Globe size={14} />All markets</span>
              {!value && <Check size={14} className="text-primary" />}
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        {markets.map((m) => (
          <DropdownMenuItem key={m.id} onSelect={() => onChange(m)} className="justify-between gap-2">
            <span className="flex items-center gap-2"><MarketFlag market={m} />{m.name}</span>
            {value?.id === m.id && <Check size={14} className="text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
